"use strict";

import { createRoot } from "react-dom/client";
import { CaptureProfileContextProvider } from "../captureprofilemanager/captureProfileContext";
import { CaptureProfileFormRendererProps, CustomEditor, FieldEditorProps } from "./types";
import { CaptureProfileForm } from "./renderform";

declare global {
  interface Window {
    CustomEditors: CustomEditor[]
  }
}

export const CaptureProfileFormRendererFromStatic = ({fields, isClient}: CaptureProfileFormRendererProps) => {
    return <CaptureProfileContextProvider fieldDefinitions={[]}>
        <CaptureProfileForm fields={fields} isClient={isClient}></CaptureProfileForm>
    </CaptureProfileContextProvider>;
}


document.querySelectorAll('[data-role="captureprofile-formbuilder"]').forEach(function (el) {

    const root = createRoot(el)

    const dateformat = el!.getAttribute('data-datepickerformat') ?? 'yyyy-mm-dd';

    const fields = Array.from(el.querySelectorAll('[data-role="captureprofile-fieldeditor"]')).map((v,i,a) => {

        var options = Array.from(v.querySelectorAll('[data-role="list"] [data-role="option"]')).map(x => {
            return x.textContent || ""
        });
        const props : FieldEditorProps = {
            alias: v!.getAttribute('data-alias')!,
            label: v!.getAttribute('data-label')!,
            editor: v!.getAttribute('data-editorname')!,
            required: (v!.getAttribute('data-required')?.toLowerCase() ?? '') === 'true',
            value: v.querySelector('input[name$=".Value"]')?.getAttribute('value') ?? '',
            originalValue: v.querySelector('input[name$=".Value"]')?.getAttribute('value') ?? '',
            disabled: v.querySelector('input[name$=".Value"]')!.getAttribute('disabled')?.toLowerCase() === 'disabled',
            readonly: v.querySelector('input[name$=".Value"]')!.getAttribute('readonly')?.toLowerCase() === 'readonly',
            valmessage: v.getAttribute('data-val-message') ?? '',
            regex: v.getAttribute('data-regex') ?? '',
            validation: v.querySelector('[data-valmsg-for="' + v.getAttribute('data-name') + '"]')!.textContent ?? '',
            id: v!.getAttribute('id') ?? '',
            extraSettings: Array.from(v.attributes).filter(p => p.name.startsWith('data-extrasettings-')).map(x => {
                return {
                    [x.name.substring(x.name.lastIndexOf('-') + 1)]: x.value
                }
            }),
            possibleValuesList: options,
            defaultValue: v!.getAttribute('data-defaultvalue')!,
            format: dateformat,
            captureProfileFieldIdFieldName: v.querySelector('input[name$=".CaptureProfileFieldId"]')?.getAttribute('name') ?? `Values[${i}].CaptureProfileFieldId`,
            valueFieldName: v.querySelector('input[name$=".Value"]')?.getAttribute('name') ?? `Values[${i}].Value`,
        }
        return props;

    });
    const props = {
        fields,
        isClient: el.getAttribute('data-isclient')?.toLocaleLowerCase() === 'true',
    };
    root.render(
        <CaptureProfileFormRendererFromStatic {...props} />
    );

});